import { getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
const { PIE, AREA } = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;
export const formatDataByRanking = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      groupByField,
      entityKey,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;
    const graphColors = getRandomUniqueColor(data.length);
    let labels = [];
    let BGcolors = [];
    let tempData = [];
    let hcPieChartData = [];
    data.length && data.sort((a, b) => b.articlecnt - a.articlecnt);
    data.forEach((elm, index) => {
      labels.push(elm[entityKey]);
      BGcolors.push(graphColors[index]);
      tempData.push(elm[countKey]);
      hcPieChartData.push({
        name: elm[entityKey],
        y: parseInt(elm[countKey], 10),
        backgroundColor: graphColors[index],
      });
    });
    const staticLabel = rType.toLowerCase().includes("ccm")
      ? "CCM"
      : rType.toLowerCase().includes("mav")
      ? "MAV"
      : "Count";
    const datasets = [
      {
        label: "",
        backgroundColor: BGcolors && BGcolors[0],
        borderColor: BGcolors,
        borderWidth: 1,
        data: tempData,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      },
    ];
    return {
      labels,
      datasets,
      hcPieChartData,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};
